"use client";

import React from "react";

import InViewProvider from "./InViewProvider";
import AssetLibraryProvider from "./AssetLibraryProvider";
import TagLibraryProvider from "@contexts/TagLibraryProvider";
import InsightsProvider from "./InsightsProvider";
import SelectedItemsProvider from "./SelectedItemsProvider";
import ViewModeProvider from "./ViewModeProvider";
import BannerProvider from "./BannerProvider";
import ThemeProvider from "./ThemeDataProvider";
import { NavPoint } from "@redux/navPoint/NavPoint";
import { ProductsProvider } from "./ProductsProvider";

type Props = {
  children: React.ReactNode;
  navPoint?: NavPoint;
};

export const ContextProviders = ({ children, navPoint }: Props) => {
  return (
    <ThemeProvider navPoint={navPoint}>
      <SelectedItemsProvider>
        <AssetLibraryProvider>
          <ProductsProvider>
            <ViewModeProvider>
              <TagLibraryProvider>
                <InsightsProvider>
                  <BannerProvider>
                    <InViewProvider>{children}</InViewProvider>
                  </BannerProvider>
                </InsightsProvider>
              </TagLibraryProvider>
            </ViewModeProvider>
          </ProductsProvider>
        </AssetLibraryProvider>
      </SelectedItemsProvider>
    </ThemeProvider>
  );
};
